var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"16px","box-sizing":"border-box","background":"#fff"}},[_c('task-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }